import React from 'react';
import mascotHappy from '../../../../assets/svg/onboarding/mascot-happy.svg';

interface ProjectSuccessModalProps {
    isOpen: boolean;
    onViewProject: () => void;
}

const ProjectSuccessModal: React.FC<ProjectSuccessModalProps> = ({
    isOpen,
    onViewProject
}) => {
    if (!isOpen) return null;

    return (
        <div className="project-success-modal-overlay">
            <div className="project-success-modal-content">
                <div className="success-modal-illustration">
                    <img src={mascotHappy} alt="Success" />
                </div>

                <h2 className="success-modal-header">
                    Your Project is Published
                </h2>

                <p className="success-modal-subtext">
                    Invite More Collaborators Or View Your Project
                </p>

                <div className="success-modal-buttons">
                    <button
                        type="button"
                        className="success-button-primary"
                        onClick={onViewProject}
                    >
                        View Project
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProjectSuccessModal;